/**
 * 动画效果工具
 * 提供撒花和烟花动画效果
 */
import confetti from 'canvas-confetti';

// 撒花动画
export const createConfetti = (options = {}) => {
  // 默认配置
  const config = {
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'],
    ...options
  };

  confetti(config);
};

// 烟花动画
export const createFireworks = (options = {}) => {
  // 默认配置
  const config = {
    particleCount: 200,
    spread: 180,
    startVelocity: 30,
    gravity: 1.2,
    ticks: 60,
    origin: { x: Math.random(), y: Math.random() * 0.6 + 0.2 },
    colors: ['#ff0000', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#ff00ff'],
    ...options
  };

  confetti(config);
};

// 多重烟花动画
export const createMultipleFireworks = (count = 5, interval = 700) => {
  let i = 0;
  const timer = setInterval(() => {
    createFireworks({
      origin: { x: Math.random(), y: Math.random() * 0.6 + 0.2 }
    });
    i++;
    if (i >= count) {
      clearInterval(timer);
    }
  }, interval);
};

// 完美成绩庆祝动画
export const createPerfectCelebration = () => {
  // 先来一波撒花
  createConfetti({
    particleCount: 150,
    spread: 90
  });
  
  // 然后是连续的烟花
  setTimeout(() => {
    createMultipleFireworks(7, 600);
  }, 500);
  
  // 最后再来一波撒花
  setTimeout(() => {
    createConfetti({
      particleCount: 200,
      spread: 160,
      origin: { y: 0.8 }
    });
  }, 2500);
};